export default "__VITE_ASSET__C5H62oUU__"